export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/sparkles-icon.png?49cadd4e938a9087967339b7ca97d9d5";